import React, { useState } from 'react';
import axios from '../axiosConfig';

const LoginModal = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        '/login.php',
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const { token } = response.data;
      localStorage.setItem('token', token);
      onLoginSuccess();
    } catch (error) {
      setError('Kullanıcı adı veya Parola hatalı!');
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Giriş</h2>
        {error && <p>{error}</p>}
        <form onSubmit={handleSubmit} className='login-form'>
          <input
            type="text"
            placeholder="Kullanıcı Adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Parola"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Giriş yap</button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
